/* ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- =============================================================================  */

  


/* ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- =============================================================================  */

/* Searchbar is focused, when the searchbutton is clicked */
document.addEventListener("DOMContentLoaded", function () {
  const searchTrigger = document.querySelector(".header__search-full");

  searchTrigger?.addEventListener("click", function () {
    setTimeout(() => {
      const searchInput = document.querySelector(".search__input");
      if (searchInput) {
        searchInput.focus();
      }
    }, 300);
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header");

  if (!header) {
    console.warn("<header> nicht gefunden.");
    return;
  }

  const moveFsbContainer = () => {
    const fsbContainer = document.getElementById("fsb_container");
    if (fsbContainer && !header.contains(fsbContainer)) {
      header.insertBefore(fsbContainer, header.firstChild);
      observer.disconnect(); // stop observing once moved
    }
  };

  // Start mit initialem Check (falls es schon da ist)
  moveFsbContainer();

  // Beobachte Änderungen im gesamten Body
  const observer = new MutationObserver(moveFsbContainer);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});





var $mainSlider = $('.productView-nav');
var $thumbSlider = $('.productView-for');

if ($mainSlider.length && $thumbSlider.length) {
  $mainSlider.on('afterChange', function(event, slick, currentSlide){
    $thumbSlider.slick('slickGoTo', currentSlide);
    $thumbSlider.find('.slick-slide').removeClass('slick-current');
    $thumbSlider.find('.slick-slide[data-slick-index="' + currentSlide + '"]').addClass('slick-current');
  });

  $thumbSlider.on('click', '.slick-slide', function(e){
    e.preventDefault();
    var index = $(this).data('slick-index');
    $mainSlider.slick('slickGoTo', index);
  });

  $mainSlider.slick('setPosition');
  $thumbSlider.slick('setPosition');
}
